<template>
  <router-link :to="{ name: routeName }">
    <!-- eslint-disable -->
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 240 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M85.3991 33.919V42.8319H78.3124C71.6992 42.8319 67.6741 38.8429 67.6741 32.2751V21.1299H62.1958V18.7526L75.6018 4.66602H77.7164V13.2969H85.2358V21.1299H77.9776V30.5263C77.9776 32.6458 79.2676 33.919 81.4475 33.919H85.3991Z" fill="#34D0B4"/>
      <path d="M109.697 13.1597V22.4674H105.696C102.047 22.4674 100.52 24.047 100.52 27.8104V42.8237H90.2163V13.2967H97.1234L98.7318 16.5766C100.838 14.167 103.41 13.1597 106.97 13.1597H109.697Z" fill="#34D0B4"/>
      <path d="M113.592 13.2969H123.895V42.8239H113.592V13.2969Z" fill="#34D0B4"/>
      <path d="M159.955 24.8205V42.8236H149.652V26.2227C149.652 22.7817 148.346 21.0813 145.749 21.0813C142.532 21.0813 140.687 23.2974 140.687 27.0528V42.8236H130.384V13.2966H137.617L139.03 16.3428C141.259 13.893 144.582 12.4263 148.452 12.4263C155.391 12.4263 159.955 17.2937 159.955 24.8205Z" fill="#34D0B4"/>
      <path d="M166.113 13.2969H176.416V42.8239H166.113V13.2969Z" fill="#34D0B4"/>
      <path d="M203.08 33.919V42.8319H195.993C189.38 42.8319 185.355 38.8429 185.355 32.2751V21.1299H179.876V18.7526L193.282 4.66602H195.397V13.2969H202.917V21.1299H195.658V30.5263C195.658 32.6458 196.948 33.919 199.128 33.919H203.08Z" fill="#34D0B4"/>
      <path d="M118.743 9.58983C121.426 9.58983 123.6 7.44308 123.6 4.79492C123.6 2.14676 121.426 0 118.743 0C116.06 0 113.885 2.14676 113.885 4.79492C113.885 7.44308 116.06 9.58983 118.743 9.58983Z" fill="#34D0B4"/>
      <path d="M171.428 9.58983C174.111 9.58983 176.285 7.44308 176.285 4.79492C176.285 2.14676 174.111 0 171.428 0C168.745 0 166.57 2.14676 166.57 4.79492C166.57 7.44308 168.745 9.58983 171.428 9.58983Z" fill="#34D0B4"/>
      <path d="M199.153 55.1616C201.836 55.1616 204.011 53.0149 204.011 50.3667C204.011 47.7185 201.836 45.5718 199.153 45.5718C196.47 45.5718 194.295 47.7185 194.295 50.3667C194.295 53.0149 196.47 55.1616 199.153 55.1616Z" fill="#34D0B4"/>
      <path d="M239.999 13.2646H229.549L227.712 18.3174H227.704L222.332 33.081L216.567 18.3174H216.551L214.584 13.2727H204.117L206.419 18.3174H206.403L217.621 42.9045C216.355 46.2408 215.278 47.1595 211.693 47.1595H209.122V55.0892H212.322C219.335 55.0892 222.699 52.1236 226.357 43.9199L237.738 18.3094L239.999 13.2646Z" fill="#34D0B4"/>
      <path d="M46.8303 21.3397C46.7732 21.3397 46.716 21.3397 46.6589 21.3397L15.234 21.1221V21.1301C14.0583 21.0737 12.8663 21.4847 11.9682 22.3631C10.2618 24.0313 10.2455 26.7551 11.9437 28.4394C12.8336 29.3258 14.0093 29.7449 15.1768 29.7046L46.6181 29.9222C47.7611 29.9544 48.9204 29.5434 49.794 28.6811C51.5004 27.013 51.5167 24.2891 49.8185 22.6049C48.9858 21.7909 47.9162 21.3719 46.8303 21.3397Z" fill="url(#paint0_linear_1_28132)"/>
      <path d="M46.5929 10.8631L29.5701 10.7422C29.5129 10.7422 29.4558 10.7422 29.3986 10.7422C28.3128 10.7583 27.2351 11.1693 26.4023 11.9832C24.6959 13.6514 24.6796 16.3752 26.3778 18.0595C27.1942 18.8734 28.2638 19.2925 29.3415 19.3247H29.3578C29.415 19.3247 29.4721 19.3247 29.5293 19.3247L46.6501 19.4456C47.7849 19.4617 48.9198 19.0507 49.7934 18.2045C51.4998 16.5364 51.5161 13.8125 49.8179 12.1283C48.928 11.2499 47.7523 10.8308 46.5929 10.8631Z" fill="url(#paint1_linear_1_28132)"/>
      <path d="M46.9609 31.7108H46.8221C46.7649 31.7108 46.7159 31.7108 46.6588 31.7108L4.43231 31.4287C3.29746 31.4045 2.15444 31.8236 1.28901 32.6698C-0.417361 34.3379 -0.43369 37.0617 1.26451 38.746C2.13811 39.6164 3.29746 40.0354 4.44864 40.0112L46.6016 40.2933C46.667 40.2933 46.7241 40.2933 46.7894 40.2933H46.9037V40.2852C47.9488 40.2449 48.9857 39.8339 49.7858 39.0442C51.4921 37.376 51.5085 34.6522 49.8103 32.9679C49.0183 32.1862 47.9978 31.7752 46.9609 31.7108Z" fill="url(#paint2_linear_1_28132)"/>
      <defs>
      <linearGradient id="paint0_linear_1_28132" x1="10.6728" y1="25.5257" x2="51.0723" y2="25.5257" gradientUnits="userSpaceOnUse">
      <stop stop-color="#57EFB8"/>
      <stop offset="0.00934389" stop-color="#57EFB8"/>
      <stop offset="0.2809" stop-color="#57EFB8"/>
      <stop offset="0.6685" stop-color="#01BCBD"/>
      <stop offset="0.8876" stop-color="#00A1D4"/>
      <stop offset="1" stop-color="#00A1D4"/>
      </linearGradient>
      <linearGradient id="paint1_linear_1_28132" x1="25.1026" y1="15.0983" x2="51.0717" y2="15.0983" gradientUnits="userSpaceOnUse">
      <stop stop-color="#57EFB8"/>
      <stop offset="0.00934389" stop-color="#57EFB8"/>
      <stop offset="0.2809" stop-color="#57EFB8"/>
      <stop offset="0.6685" stop-color="#01BCBD"/>
      <stop offset="0.8876" stop-color="#00A1D4"/>
      <stop offset="1" stop-color="#00A1D4"/>
      </linearGradient>
      <linearGradient id="paint2_linear_1_28132" x1="-0.000974667" y1="35.863" x2="51.0722" y2="35.863" gradientUnits="userSpaceOnUse">
      <stop stop-color="#57EFB8"/>
      <stop offset="0.00934389" stop-color="#57EFB8"/>
      <stop offset="0.2809" stop-color="#57EFB8"/>
      <stop offset="0.6685" stop-color="#01BCBD"/>
      <stop offset="0.8876" stop-color="#00A1D4"/>
      <stop offset="1" stop-color="#00A1D4"/>
      </linearGradient>
      </defs>
    </svg>
  </router-link>
</template>

<script>
export default {
  name: 'LogoTrinity',
  props: {
    routeName: {
      type: String,
      default: 'Home',
    },
    width: {
      type: Number,
      default: 240,
    },
    height: {
      type: Number,
      default: 56,
    },
  },
};
</script>

<style>
</style>
